import React from "react";
import Footer from "../../Shared/Footer/Footer";
import Navigation from "../../Shared/Navigation/Navigation";
import About from "../About/About";
import Banner from "../Banner/Banner";
import Contact from "../Contact/Contact";
import Projects from "../Projects/Projects";
import Skills from "../Skills/Skills";

const Home = () => {
  return (
    <div id="home">
      <Navigation className="bg-transparent"></Navigation>
      <div className="text-white" style={{ backgroundColor: "#030303" }}>
        <Banner></Banner>
        <About></About>
        <Projects></Projects>
        <Skills></Skills>
        <Contact></Contact>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Home;
